var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MNotification'),_c('OHeader'),(_vm.isStructuredGalleryActive || _vm.galleryActive)?_c('MStructuredGallery',{class:{
      'hidden-gallery-main': !_vm.isStructuredGalleryActive || !_vm.galleryActive,
      'open-gallery-main': _vm.galleryActive,
    },attrs:{"gallery":_vm.getGalleryByLink.gallery.all,"albumTitle":_vm.getGalleryByLink.albumTitle,"galleryInfo":_vm.getGalleryByLink.galleryInfo,"galleryNote":_vm.getGalleryByLink.galleryNote}}):_vm._e(),_c('router-view'),_c('OFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }